// extracted by mini-css-extract-plugin
export var root = "_2b6004bd87eeecf14b6f4c9969317e45-css";
export var popoverContent = "_566844fc4744a665529b658a6330b51a-css";